import { KnowledgeFileData } from '../interfaces/Knowledge';
import { handleServiceError } from '../helpers/app';
import { ResponseObject } from '../interfaces/App';
import Knowledge from '../interfaces/Knowledge';
import apiRequest from './apiService';

const createKnowledge = async (data: Knowledge) => {
  try {
    const result = await apiRequest(
      'agent',
      'POST',
      '/knowledge/create_knowledge',
      data,
      null,
      60000
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'knowledge');
  }
};

const getKnowledge = async (id: string) => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      `/knowledge/get_knowledge/${id}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'knowledge');
  }
};

const getKnowledgesByUserId = async (userId: string) => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      `/knowledge/get_knowledges_by_user_id/${userId}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'knowledge');
  }
};

const updateKnowledge = async (id: string, data: Partial<Knowledge>) => {
  try {
    const result = await apiRequest(
      'agent',
      'PUT',
      `/knowledge/update_knowledge/${id}`,
      data
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'knowledge');
  }
};

const deleteKnowledge = async (id: string) => {
  try {
    const result = await apiRequest(
      'agent',
      'DELETE',
      `/knowledge/delete_object/${id}`,
      null,
      null,
      30000 // 30 seconds before timing out
    );
    return result;
  } catch (err: unknown) {
    handleServiceError(err, 'knowledge');
  }
};

const isKnowledgeAttachedToAgent = async (id: string) => {
  try {
    const result: ResponseObject = await apiRequest(
      'agent',
      'GET',
      `/knowledge/check_knowledge_agent_association/${id}`
    );
    return result;
  } catch (err: unknown) {
    handleServiceError(err, 'knowledge');
  }
};

const searchKnowledgeFiles = async (knowledgeId: string, query: string) => {
  try {
    const result: ResponseObject = await apiRequest(
      'agent',
      'GET',
      `/knowledge/${knowledgeId}/search_files`,
      null,
      { query }
    );
    return result;
  } catch (error: unknown) {
    handleServiceError(error, 'knowledge');
  }
};

/*
 *
 * APIs for uploading and deleting knowledge files.
 *
 */

const createKnowledgeFile = async (
  knowledgeId: string,
  knowledgeFileData: KnowledgeFileData
) => {
  try {
    const result = await apiRequest(
      'agent',
      'POST',
      `/knowledge/${knowledgeId}/add_knowledge_file`,
      {
        file_name: knowledgeFileData.name,
        file_content: knowledgeFileData.content,
      },
      null,
      120000 // 2 minutes before timing out
    );
    return result;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

const deleteKnowledgeFile = async (
  knowledgeId: string,
  knowledgeFileName: string
): Promise<ResponseObject> => {
  try {
    const result = await apiRequest(
      'agent',
      'DELETE',
      `/knowledge/${knowledgeId}/delete_knowledge_file`,
      null,
      { file_name: knowledgeFileName },
      30000 // 30 seconds beforing timing out
    );
    return result;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

// `inline` asks for a URL the browser renders (PDF only) instead of downloading
const getFileDownloadUrl = async (
  knowledgeId: string,
  knowledgeFileName: string,
  disposition?: 'inline'
): Promise<ResponseObject> => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      `/knowledge/${knowledgeId}/get_file_download_url`,
      null,
      { file_name: knowledgeFileName, disposition },
      30000 // 30 seconds before timing out
    );
    return result;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export {
  createKnowledge,
  createKnowledgeFile,
  deleteKnowledge,
  deleteKnowledgeFile,
  getFileDownloadUrl,
  getKnowledge,
  getKnowledgesByUserId,
  isKnowledgeAttachedToAgent,
  searchKnowledgeFiles,
  updateKnowledge,
};
